import { useEffect, useState } from "react";
import { useLanguage } from "../../../context/LanguageContext";
import { useAlert } from "../../../Hooks/useAlert";
import { milkRateAPI } from "../../../services/api";
import settingsLanguage from "../../../language/settingsLanguage";
import Alert from "../../common/Alert";
import BackButton from "./BackButton";

function MilkRatePage() {
  const { language } = useLanguage();
  const text = settingsLanguage[language];
  const { showAlert, alertConfig } = useAlert();
  const [loading, setLoading] = useState(false);
  const [cowRate, setCowRate] = useState(0);
  const [buffaloRate, setBuffaloRate] = useState(0);

  useEffect(() => {
    loadMilkRates();
  }, []);

  const loadMilkRates = async () => {
    try {
      const response = await milkRateAPI.getMilkRates();
      if (response.success) {
        setCowRate(response.data.cowRate);
        setBuffaloRate(response.data.buffaloRate);
      }
    } catch (error) {
      console.error("Error loading milk rates:", error);
    }
  };

  const handleSaveRates = async () => {
    setLoading(true);
    try {
      const response = await milkRateAPI.updateMilkRates(cowRate, buffaloRate);
      if (response.success) {
        await showAlert({
          type: "success",
          title: "Success",
          message: "Milk rates updated successfully!",
        });
      } else {
        await showAlert({
          type: "error",
          title: "Error",
          message: "Failed to update rates.",
        });
      }
    } catch (error) {
      console.error("Error updating rates:", error);
      await showAlert({
        type: "error",
        title: "Error",
        message: "Error updating rates.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="settings-page">
      <header className="settings-page-header">
        <BackButton to="/settings" section="master" />
        <h1 className="settings-page-title">{text.milkRateMaster}</h1>
      </header>

      <main className="settings-page-content">
        <div className="settings-form-card">
          <div className="settings-form-body">
            <div className="settings-form-group">
              <label className="settings-form-label">{text.cowMilkRateMaster}</label>
              <input
                type="number"
                step="0.01"
                value={cowRate}
                onChange={(e) => setCowRate(parseFloat(e.target.value))}
                className="settings-form-input"
                placeholder={text.enterCowRate}
              />
            </div>

            <div className="settings-form-group">
              <label className="settings-form-label">{text.buffaloMilkRateMaster}</label>
              <input
                type="number"
                step="0.01"
                value={buffaloRate}
                onChange={(e) => setBuffaloRate(parseFloat(e.target.value))}
                className="settings-form-input"
                placeholder={text.enterBuffaloRate}
              />
            </div>

            <div className="settings-form-actions">
              <button
                type="button"
                onClick={handleSaveRates}
                disabled={loading}
                className="settings-form-btn"
              >
                <i className="fas fa-save" />
                <span>{loading ? text.saving : text.saveRates}</span>
              </button>
            </div>
          </div>
        </div>
      </main>

      {alertConfig && <Alert {...alertConfig} />}
    </div>
  );
}

export default MilkRatePage;
